const nerdamer = require('nerdamer/all')
import {BaseLayout} from "./baseLayout"
import Big from "big.js"
import {awi_readings_X, awi_dev_std_max, MPE} from "./report_utility"

export const AwiTable = {
    props: ['stub','headers', 'instrument', 'mpeIntervals', 'primaries', 'radioMPE', 'preview', 'isPretest', 'isTare', 'calculateNum','resolution','prec', 'high_prec', 'op_types'],
    mixins: [BaseLayout],
    data() {
        return {
            measures: {
                mass: null,
                items: [],
                mpe: null,
                max_error: null,
                mean_error: null,
                num: 0,
                hi_res: 0,
                result: false,
                selected_primary: null
            },
            precision: null,
            high_precision: null,
            started: false,
            positions: ["centrale", "sopra", "sotto"]
        }
    },
    watch: {
        'measures': {
            deep: true,
            handler() {
                if(!this.preview){
                    this.debouncedSave()
                }
            }
               
        },
        'mpeIntervals':{
            immediate: false,
            handler(){
                if(!this.preview){
                    this.handleMPE()
                }
            }
        },
        'resolution':{
            handler(){
                this.$set(this.measures, "hi_res", this.resolution)
            }
        },
        'prec': {
            handler(){
                this.precision = this.prec
            }
        },
        'high_prec': {
            handler(){
                this.high_precision = this.high_prec
            }
        }
    },
    methods:{
        findPrimaryPrecision(){
            if(this.measures.selected_primary){
                let primary = this.measures.selected_primary
                if(primary != null && primary.platforms.length > 0){
                    return primary.platforms[0].digits
                } 
            }
            return 0
        },
        findPrimaryDiv(){
            if(this.measures.selected_primary){
                let p = this.measures.selected_primary
                if(p != null && p.platforms.length > 0){
                    let maxR = this.findMaxRange(p.platforms[0])
                    if (p.platforms[0].instrument_class > 0){
                        return maxR.e
                    } else {
                        return maxR.d
                    }
                }
            } else {
               return null 
            }
        },
        checkPrimaryDiv(value){
            let div = this.findPrimaryDiv()
            let r = this.checkDivisions(value,div)
            return r
        },
        calculateStatus(){
            this.measures.max_error = this.calculate_max_error()
            this.measures.result = this.calculateResult()
        },
        calculate_max_error(){
            if(this.formulas && this.formulas['formula:massimo']){
                let formula_max = this.formulas['formula:massimo']
                let items = this.measures.items.map(i => this.round(Big(i.error).abs().toString(), this.compPrimaryPrecision))
                let paramName = Object.keys(formula_max.data)[0] // name of the variable, like a in stdev(a)
                var test = formula_max.equation.replace(paramName, items.toString())
                let pippo = nerdamer(test).evaluate().text()
                return this.round(pippo, this.compPrimaryPrecision)
            } else {
                return this.round(0, this.compPrimaryPrecision)
            }
        },
        calculate_mean_error(){
            if(this.formulas && this.formulas['formula:media']){
                let formula = this.formulas['formula:media']
                let items = this.measures.items.map(i => this.round(Big(i.error).abs().toString(), this.compPrimaryPrecision))
                let paramName = Object.keys(formula.data)[0] // name of the variable, like a in stdev(a)
                var test = formula.equation.replace(paramName, items.toString())
                let pippo = nerdamer(test).evaluate().text()
                return this.round(pippo, this.stDevPrecision)
            } else {
                return this.round(0, this.stDevPrecision)
            }
        },
        calc_MPE(currentRange, actualMass, mpeIntervals = [1, 2, 3]) {
            if (currentRange) {
                let div = this.instrument_data.instrument_class ? currentRange.e : currentRange.d
                return this.round(MPE(this.instrument_data.instrument_class, [div], currentRange.div_nr, actualMass, mpeIntervals), this.precision + 1)
            } else {
                return this.round("0", this.precision + 1)
            }
        }, // da modificare quando ci saranno specifiche 1.15: precision + 1 non è bello
        handleMPE(){
            if(this.instrument_data && this.measures.mass){
                if(this.isTare){
                    let minRange = this.calcMinRange(this.measures.netVal)
                    let newMPE = this.calc_MPE(minRange, this.measures.netVal, this.mpeIntervals)
                    this.$set(this.measures, "mpe", newMPE)
                } else {
                    let minRange = this.calcMinRange(this.measures.mass)
                    let newMPE = this.calc_MPE(minRange, this.measures.mass, this.mpeIntervals)
                    this.$set(this.measures, "mpe", newMPE)
                }
            }
        },
        calculateSingleResult(value, mpe){
            if(value && mpe){
                if(Big(value).abs().lte(mpe)){
                    return "done"
                } else {
                    return "failed"
                }
            } else {
                return "uncomplete"
            }
        },
        calculateError(row){
            let nomVal = this.isTare ? this.measures.netVal : this.measures.mass
            if(nomVal && row.reading){
                row.error = this.round(Big(nomVal).minus(row.reading), this.compPrimaryPrecision)
                row.result = this.calculateSingleResult(row.error, this.measures.mpe)  // result is used only  in Y
            } else {
                console.log("$$ error: mass or reading are null")
                row.error = this.round("0")
            }
            this.calculateStatus()
        },
        approximateMass(val = this.measures.mass){
            let range = this.calcMinRange(val)
            let minDiv = this.calculateMinDiv(range)
            let mod = Big(val).mod(minDiv)
            let half = Big(minDiv).times(0.5)
            let base = Big(val).minus(mod)
            if(mod.gte(half)){
                return this.round(base.plus(minDiv))
            } else {
                return this.round(base)
            }
        },
        buildMeasures(val = this.measures.mass){
            this.measures.items.splice(0, this.measures.items.length)
            for(let i = 0; i < this.measures.num; i++){
                let item = {
                    reading: this.approximateMass(val),
                    error: 0,
                    n: i+1,
                    status: "uncomplete"
                }
                this.measures.items.push(item)
            }
        },
        saveMeasures(){
            this.$emit('update', this.stub.index, this.measures)
        },
        calculateStartval(val = this.measures.mass){
            if(this.instrument.digits != undefined && this.instrument.digits != null){
                return val ? this.round(val) : this.round("0")
            } else {
                return this.round("0")
            }
        },
        calculateResult(){
            if(this.measures.mpe && this.measures.max_error){
                if(Big(this.measures.max_error).abs().gt(this.measures.mpe)){
                    return false
                } else {
                    return true
                }
            }
            return false
        },
        beforeMountBuilder(){
            // console.log("$$$$$ stub op", this.stub)
            this.instrument_data = this.instrument
            this.precision = this.prec
            this.high_precision = this.high_prec
            if(this.stub.data != null && this.stub.data != undefined){
                // console.log("$$ building from stub", this.stub.data)
                this.measures = _.cloneDeep(this.stub.data)
                this.started = true
            } else{
                this.$set(this.measures, "hi_res", this.resolution)
                if(this.isTare){
                    if(this.stub.tareBuilder){
                        let tarebuilder = this.stub.tareBuilder
                        this.$set(this.measures, "nom", tarebuilder.nom)
                        this.$set(this.measures, "mass", tarebuilder.conv)
                        this.$set(this.measures, "tare", tarebuilder.tare)
                        this.$set(this.measures, "netVal", tarebuilder.netVal)
                        this.calculateReadings(this.measures.netVal)
                    }
                } else {
                    if(this.stub.startValue) {
                        this.$set(this.measures, "nom", this.stub.startValue)
                    }
                }
                if(this.primaries.length == 1){
                    this.measures.selected_primary = this.primaries[0]
                }
                console.log("$$ first build")
                this.started = false
            } 
        },
        findFormulas(){
            if(this.stub.formulas){
                for(let formulaID of this.stub.formulas){
                     this.$store.state.$pouch.find('masters', {selector: {_id: formulaID}}).then(
                        res => {
                            if(res.docs.length > 0){
                                this.formulas[formulaID] = res.docs[0]
                            }
                        })
                        // console.log("$$ added formula", formulaID)
                }
                // console.log("$$ all formulas", this.formulas)
            }
        },
        changeDiv(item, op){
            let range = this.calcMinRange(item.reading)
            if(range){
                let div = this.calculateMinDiv(range)
                if(op === "add"){
                    item.reading = this.round(Big(item.reading).plus(div))
                } else if (op === "sub"){
                    item.reading = this.round(Big(item.reading).minus(div))
                }
                this.calculateError(item)
            }
        },
        handleMass(value){
            if(!this.measures.nom || !value){
                return 'error_field'
            }
            let div_ok = this.checkPrimaryDiv(value)
            if(!div_ok){
                return 'error_field'
            }
            let range = this.calcMinRange(this.measures.nom)
            if(range == null){
                return 'error_field'
            }
            if (this.radioMPE === "mpeRounded"){
                return null
            }
            if(this.instrument_data.instrument_class){
                if(Big(range.d).lte(Big(range.e).times(0.2))){
                    return null
                }
            }
            let diff = Big(0)
            let diff1 = Big(0)
            let div = this.calculateMinDiv(range)
            if(Number.isInteger(this.measures.mpe)){
                diff = Big(value).minus(this.measures.nom).minus(Big(div).times(0.5))
                diff1= Big(value).minus(this.measures.nom).plus(Big(div).times(0.5))
            } else {
                diff = Big(value).minus(this.measures.nom)
            }
            if(Big(Big(diff).abs()).lte(0.1) || Big(Big(diff1).abs()).lte(0.1)){
                return null
            } else {
                return 'error_field'
            }            
        },
        handleTare(value){
            if(!value){
                return 'error_field'
            }
            let div_ok = this.checkPrimaryDiv(value)
            if(!div_ok){
                return 'error_field'
            }
        },
        calculate_dev_std(){
            if(this.formulas && this.formulas['formula:deviazioneStandard'] && this.measures.items.length > 0){
                let formula_dev = this.formulas['formula:deviazioneStandard']
                let temp = this.measures.items.map(x => this.round(Big(x.error).abs().toString(), this.compPrimaryPrecision))
                let paramName = Object.keys(formula_dev.data)[0] // name of the variable, like a in stdev(a)
                var test = formula_dev.equation.replace(paramName, temp.toString())
                let pippo = nerdamer(test).evaluate().text()
                return this.round(pippo, this.stDevPrecision)
            } 
            return this.round(0, this.stDevPrecision)
        },
        calculateReadings(mass){
            if(mass){
                if(this.calculateNum){
                    this.measures.num = awi_readings_X(mass, this.instrument.uom) 
                } else {
                    this.measures.num = 10
                }
            }
        },
        changeMassX(temp = this.measures.mass){
            // this.measures.num = awi_readings_X(temp, this.instrument.uom)
            this.buildMeasures(temp)
            let currVal = this.calculateStartval(temp)
            if(!this.isPretest){
                this.measures.stdev_allowed = awi_dev_std_max(currVal, this.instrument.uom, this.stdevIntervals)
            }
            this.allErrors()
            console.log("$$ debug intervals", this.mpeIntervals)
            this.handleMPE()
            this.started = true
        },
        changeMassY(temp = this.measures.mass){
            // if(this.calculateNum){
            //     this.measures.num = awi_readings_X(temp, this.instrument.uom)
            // } else {
            //     this.measures.num = 10
            // }
            this.buildMeasures(temp)
            this.allErrors()
            this.handleMPE()
            this.started = true
        },
        allErrors(){
            for(let elem of this.measures.items){
                this.calculateError(elem)
            }   
        },
        calculateResultWithStdev(){
            if(this.measures.mpe && this.measures.stdev_allowed && this.measures.stdev && this.measures.mean_error){
                if(Big(this.measures.stdev).gte(this.measures.stdev_allowed) || Big(Big(this.measures.mean_error).abs()).gte(this.measures.mpe)){
                    return false
                }
                return true
            }
            return false
        },
        calculateNetVal(){
            console.log("calculating net val", this.measures.mass, this.measures.tare, this.measures.netVal)
            if(this.measures.mass && this.measures.tare){
                this.$set(this.measures, 'netVal', this.round(Big(this.measures.mass).minus(this.measures.tare), this.compPrimaryPrecision))
            }
            this.calculateReadings(this.measures.netVal)
        }
    },
    computed: {
        isNotEditable(){
            if(this.preview){
                return true
            } else if(this.started){
                return true
            } else {
                return false
            }
        },
        compPrimaryPrecision(){
            console.log("primary selected", this.measures.selected_primary)
            return this.findPrimaryPrecision()
        },
        measuresResult(){
            if(this.measures.result){
                return "done"
            } else {
                return "failed"
            }
        },
        mean_result(){
            if(this.measures.mean_error && this.measures.mpe){
                let temp = Big(this.measures.mean_error).lte(this.measures.mpe)
                if(temp){
                    return "done"
                } else {
                    return "failed"
                }
            }
            return "uncomplete"
        },
        max_result(){
            if(this.measures.max_error && this.measures.mpe){
                let temp = Big(this.measures.max_error).lte(this.measures.mpe)
                if(temp){
                    return "done"
                } else {
                    return "failed"
                }
            }
            return "uncomplete"
        },
        stdev_result(){
            if(this.measures.stdev && this.measures.stdev_allowed){
                let temp = Big(this.measures.stdev).lte(this.measures.stdev_allowed)
                if(temp){
                    return "done"
                } else {
                    return "failed"
                }
            }
            return "uncomplete"
        },
        noPrimarySelected(){
            if(this.measures.selected_primary){
                return false
            } else {
                return true
            }
        },
        stDevPrecision(){
            return this.countDecimals(this.measures.stdev_allowed)
        }
    },
}